import { useQuery } from "@tanstack/react-query";
import { duration } from "../components/MainV2Screen/components/VisitMapCard";
import { getDistance } from "../GeoService";
import { Geo } from "../messages";
import { fmap } from "../utils/fmap";

export const useTravelTimesEstimator = (params: { source: Geo; destination: Geo }) =>
  useQuery({
    queryKey: ["travelTimes", params] as const,
    queryFn: async ({ queryKey: [_, { source, destination }] }) => {
      const [carTravelTime, busTravelTime, walkTravelTime] = await Promise.all([
        getDistance(source, destination, 2000, google.maps.TravelMode.DRIVING),
        getDistance(source, destination, 2000, google.maps.TravelMode.TRANSIT),
        getDistance(source, destination, 2000, google.maps.TravelMode.WALKING),
      ]);

      return {
        carTravelTime: fmap(carTravelTime.duration, duration),
        busTravelTime: fmap(busTravelTime.duration, duration),
        walkTravelTime: fmap(walkTravelTime.duration, duration),
      };
    },
    staleTime: Infinity,
  });
